<script>
  import { _ } from "./i18n.js";
  import { createEventDispatcher } from "svelte";
  const chooseFileLabel = $_("customFileInput.label");
  export let accept;
  const dispatch = createEventDispatcher();
  function forward(e) {
    dispatch("input", e.target.files);
  }

  function change(e) {
    let input = e.target;
    let files = e.target.files;
    var fileName = "";

    if (files && files.length > 1)
      fileName = (input.getAttribute("data-multiple-caption") || "").replace(
        "{count}",
        files.length
      );
    else {
      fileName = input.value.split("\\").pop();
    }

    let labelNode = input.nextElementSibling.nextElementSibling;
    if (fileName) {
      labelNode.innerHTML = fileName;
    } else {
      labelNode.innerHTML = chooseFileLabel;
    }
  }

  function focus(e) {
    e.target.classList.add("has-focus");
  }

  function blur(e) {
    e.target.classList.remove("has-focus");
  }
</script>

<style>
  .inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .inputFileLabel {
    max-width: 80%;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    color: rgb(0, 122, 255);
  }

  .inputFileLabel:focus,
  .inputFileLabel.has-focus {
    outline: 1px dotted #000;
    outline: -webkit-focus-ring-color auto 5px;
  }

  .inputFileLabel:focus,
  .inputFileLabel.has-focus,
  .inputFileLabel:hover {
    color: #035594;
  }
</style>

<label class="inputFileLabel">
  <input
    type="file"
    {accept}
    class="inputfile"
    on:change={change}
    on:focus={focus}
    on:blur={blur}
    on:input={forward} />
  <span class="icon icon-upload" />
  <span>{chooseFileLabel}</span>
</label>
